import React from 'react';
import { useMetricParam } from '../hooks/useMetricParam';
import { MetricDashboard } from '../components/dashboard/MetricDashboard';
import { RetentionView } from '../components/retention/RetentionView';
export function Dashboard() {
  const [metric] = useMetricParam();
  return metric === 'retention' ? <RetentionView data-id="element-762" data-mp="yp3a5io8ce28" /> : <MetricDashboard key={metric} metric={metric} data-id="element-763" data-mp="yqo6ndu3u72q" />;
}